import React from 'react';
import {useTranslation} from 'react-i18next';
import PropTypes from 'prop-types';

import {Button, BUTTON_VARIANTS, ICON_NAMES, Typography} from '@nur-portal/ui-kit';

import {handleLoginEvent} from '../../../modules/auth-buttons';
import {REACTION_ICON_SIZES} from '../../../modules/comments/reactions/constants';
import {useUser} from '../../hooks/use-user';
import {useArticleReactions} from '../../hooks/useArticleReactions';
import {dispatchArticleAuthModal} from '../article-auth-modal/constants';
import ArticleReactionsList from '../article-reactions-list';
import '../../i18n/config';

import styles from './article-reactions-widget.module.css';

const ArticleReactionsWidget = ({articleId, callback, variant}) => {
  const {t, i18n} = useTranslation();
  const {isAuthenticated} = useUser();
  const isMobile = window.Site.targeting.platform === 'smartphone';
  const layoutSection = isMobile ? 'bottom_navigation_bar' : 'left_navigation_bar';
  const {allReactions, userReaction, onSetUserReaction} = useArticleReactions(articleId, false, layoutSection);

  const onReactionClick = reactionType => {
    if (!isAuthenticated) {
      handleLoginEvent(() => onSetUserReaction(reactionType));
      dispatchArticleAuthModal();
      return;
    }

    onSetUserReaction(reactionType);
  };

  return (
    <div className={styles.container}>
      <Button
        isIconButton
        iconName={ICON_NAMES.CLOSE_24}
        variant={BUTTON_VARIANTS.GHOST}
        className={styles.closeIcon}
        onClick={() => callback()}
      />
      <Typography variant={i18n.language === 'www' ? 'title-16' : 'title-14'} className={styles.title}>
        {t('articleReactions.title')}
      </Typography>
      <ArticleReactionsList
        onReactionClick={reactionType => onReactionClick(reactionType)}
        userReaction={userReaction || ''}
        currentReactions={allReactions || {}}
        variant={variant}
        size={REACTION_ICON_SIZES.SMALL}
      />
    </div>
  );
};

ArticleReactionsWidget.propTypes = {
  articleId: PropTypes.string.isRequired,
  callback: PropTypes.func.isRequired,
  variant: PropTypes.oneOf(['primary', 'secondary'])
};

ArticleReactionsWidget.defaultProps = {
  variant: 'secondary'
};

export {ArticleReactionsWidget};
